













































import { Component, Prop, Vue } from "vue-property-decorator";
import PerencanaanTable from "./PerencanaanTable.vue";

@Component({
  components: {
    PerencanaanTable
  }
})
export default class PerencanaanModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Array, default: () => [] }) planningList!: any[];
  @Prop({ type: Boolean, default: false }) loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly: boolean;
  @Prop({ type: Boolean, default: false }) canCopy: boolean;
  @Prop({ type: Object, default: null }) stoppingItem!: number | null;
  @Prop({ type: Object, default: null }) deletingItem!: number | null;
  @Prop({ type: Object, default: null }) verifyingItem!: number | null;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit("input", value);
  }
}
